import styled from 'styled-components';

const ExternalLink = styled.a.attrs({
  target: '_blank',
  rel: 'noreferrer',
})`
  display: block;
`;

export default ExternalLink;
